import React, { useEffect, useState } from "react";
import IconAndTextButton from "../Atoms/Buttons/IconAndTextButton";
import CustomTextField from "../Atoms/TextFields/CustomTextField";
import CustomDropdown from "../Atoms/DropDowns/CustomDropdown";
import plusIcon from "../../assets/u_plus.svg";
import upload from "../../assets/upload.svg";

import { useNavigate } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import { Chip, CircularProgress } from "@mui/material";
import { useAgent } from "../../contexts/AgentsContext";
import { useDashboard } from "../../contexts/DashboardContext";
import usePermissions from "../../hooks/userPermissions";

const AgentHeader = ({
  setSearchKey,
  setStatusVal,
  setProviderFilterVal,
  setIndustryFilterVal,
  setSectorFilterVal,
  setFunctionFilterVal = () => { },
}) => {
  const navigate = useNavigate();

  const { canAgentCreate } = usePermissions();

  const { changeUploadDrawerState } = useDashboard();

  const {
    isSilentLoading,
    fetchAgentBFs,
    lookUpValues,
    fetchAgentProviders,
    fetchAgentIndustries,
    fetchAgentSectors,
    fetchAgentStatus,
    isLoadingDropdownFields,
    fetchAgentSectorsSilently,
    isFetchingSectorsSilently
  } = useAgent();

  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [industryFilter, setIndustryFilter] = useState();
  const [providerFilter, setProviderFilter] = useState();
  const [sectorFilter, setSectorFilter] = useState();
  const [statusFilter, setStatusFilter] = useState();
  const [sectorValues, setSectorValues] = useState([]);

  const debouncedText = useDebounce(searchText);

  useEffect(() => {
    const fetchDropdownValues = async () => {
      await Promise.allSettled([
        fetchAgentBFs(),
        fetchAgentIndustries(),
        fetchAgentProviders(),
        fetchAgentSectors(),
        fetchAgentStatus(),
      ]);
    };

    fetchDropdownValues();
  }, [fetchAgentBFs, fetchAgentProviders]);

  const handleSearchKeyChange = (e) => {
    setSearchText(e.target.value);
  };

  useEffect(() => {
    if (debouncedText !== undefined) {
      setSearchKey(debouncedText);
    }
  }, [debouncedText]);

  const handleFilterChange = (value) => {
    setStatusVal(value);
    setStatusFilter(value);
  };

  const handleFilterProviderChange = (value) => {
    setProviderFilterVal(value);
    setProviderFilter(value);
  };

  const handleFilterIndustryChange = async (value) => {
    setSectorValues([]);
    setIndustryFilterVal(value);
    setIndustryFilter(value);

    const industriesFromApi = await fetchAgentSectorsSilently(value);
    if (industriesFromApi) {
      setSectorValues(industriesFromApi);
    }
  };
  const handleFilterSectorChange = (value) => {
    setSectorFilterVal(value);
    setSectorFilter(value);
  };

  const handleChipClick = (chipValue) => {
    setSelectedCategory((prev) => {
      let newSelection;

      if (chipValue === "All") {
        newSelection = ["All"];
      } else {
        const isAlreadySelected = prev.includes(chipValue);
        const filteredPrev = prev.filter((item) => item !== "All");
        newSelection = isAlreadySelected
          ? filteredPrev.filter((item) => item !== chipValue)
          : [...filteredPrev, chipValue];
      }

      setFunctionFilterVal(newSelection.includes("All") ? [] : newSelection);
      return newSelection;
    });
  };
  const handleClearCategories = () => {
    setSelectedCategory([]);
    setFunctionFilterVal([]);
  };
  useEffect(() => {
    setFunctionFilterVal([]);
  }, []);
  return (
    <article className="dashboard-header">
      <div style={{ padding: "32px 48px" }}>
        <section className="d-flex justify-content-between align-items-center mb-4">
          <div className="wd-60 d-flex gap-3 align-items-center">
            <div className="wd-48">
              <CustomTextField
                clsNames={"custom-text-field-container"}
                placeholder={"Search"}
                value={searchText}
                handleOnChange={(e) => {
                  handleSearchKeyChange(e);
                }}
              />
            </div>
            <div className="dropdown-agent-header-css" style={{ minWidth: "14.5%", width: "auto" }}>
              <CustomDropdown
                selectValues={[
                  { value: "All", label: "All" },
                  ...(lookUpValues?.industries || []).map(industry => ({
                    value: industry,
                    label: industry
                  })),
                ]}
                value={industryFilter}
                name="industry"
                handleOnChange={(val) => {
                  handleFilterIndustryChange(val);
                }}
                dropdownLabel={"Industry"}
                clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
                disabled={isLoadingDropdownFields?.industries}
              />
            </div>
            <div className="dropdown-agent-header-css">
              <CustomDropdown
                selectValues={[
                  { value: "All", label: "All" },
                  ...(sectorValues || []).map(sector => ({
                    value: sector,
                    label: sector
                  })),
                ]}
                value={sectorFilter}
                name="sector"
                handleOnChange={(val) => {
                  handleFilterSectorChange(val);
                }}
                dropdownLabel={"Sector"}
                clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
                disabled={isLoadingDropdownFields?.sectors || isFetchingSectorsSilently || sectorValues.length === 0}
              />
            </div>
            <div className="dropdown-agent-header-css">
              <CustomDropdown
                selectValues={[
                  { value: "All", label: "All" },
                  ...(lookUpValues?.status || []).map(status => ({
                    value: status,
                    label: status
                  })),
                ]}
                value={statusFilter}
                name="status"
                handleOnChange={(val) => {
                  handleFilterChange(val);
                }}
                dropdownLabel={"Status"}
                clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
                disabled={isLoadingDropdownFields?.status}
              />
            </div>
            <div className="dropdown-agent-header-css">
              <div className="d-flex align-items-center">
                <CustomDropdown
                  selectValues={[
                    { value: "All", label: "All" },
                    ...(lookUpValues?.providers || []).map((provider) => ({
                      value: provider,
                      label: provider,
                    })),
                  ]}
                  value={providerFilter}
                  handleOnChange={(val) => {
                    handleFilterProviderChange(val);
                  }}
                  dropdownLabel={"Provider"}
                  clsNames={"mas-cust-dd-primary mas-cust-dd-2"}
                  disabled={isLoadingDropdownFields?.providers}
                />
                {(isLoadingDropdownFields?.providers || isLoadingDropdownFields?.industries || isLoadingDropdownFields?.sectors || isLoadingDropdownFields?.status || isFetchingSectorsSilently) && <CircularProgress
                  className="ms-2"
                  style={{ width: "15px", height: "15px", opacity: 0.8 }}
                />}
              </div>
            </div>
          </div>

          {canAgentCreate && (
            <div className="d-flex align-items-center gap-2">
              {isSilentLoading && (
                <div className="d-flex align-items-center justify-content-center">
                  <CircularProgress
                    style={{ width: "15px", height: "15px", opacity: 0.8 }}
                  />
                  <div className="sml-font ms-2">Fetching...</div>
                </div>
              )}
              {/* <IconAndTextButton
                icon={<img src={upload} alt="Upload" />}
                text="Upload"
                iconPos="left"
                iconStyles={{ width: 20, height: 20, marginRight: 4 }}
                clsNames="mas-secondary-btn-3 mas-btn-lg"
                onClickFn={() => {
                  changeUploadDrawerState(true);
                }}
              /> */}

              <IconAndTextButton
                icon={<img src={plusIcon} alt="Register Agent" />}
                text="Register Agent"
                iconPos="left"
                iconStyles={{ width: 20, height: 20, marginRight: 4 }}
                clsNames="mas-plus-icon-btn-3"
                onClickFn={() => {
                  navigate("register-agent");
                }}
              />
            </div>
          )}
        </section>
        <section>
          <div className="d-flex align-items-center">
            {lookUpValues?.bFs?.length > 0 &&
              ["All", ...lookUpValues.bFs].map((item, index) => (
                <Chip
                  clickable
                  key={index}
                  label={item}
                  onClick={() => handleChipClick(item)}
                  className="categoryChipClass"
                  sx={
                    selectedCategory.includes(item)
                      ? { backgroundColor: "#A0DCFF99" }
                      : { backgroundColor: "#FFFFFF" }
                  }
                />
              ))}
            {isLoadingDropdownFields?.bFs && (
              <div className="d-flex align-items-center justify-content-center">
                <CircularProgress
                  style={{ width: "15px", height: "15px", opacity: 0.8 }}
                />
                <div className="sml-font ms-2">Loading...</div>
              </div>
            )}
            {lookUpValues?.bFs?.length > 0 && selectedCategory.length > 0 && (
              <Chip
                label="Reset all"
                clickable
                onClick={handleClearCategories}
                className="categoryChipClass"
                id="clearAllChip"
              />
            )}
          </div>
        </section>
      </div>
    </article>
  );
};

export default AgentHeader;
